import { API } from "@/services"

export const SIP_LOGS_ENDPOINTS = {
  webList(params = {}, extra) {
    return API.Axios.error_capture.v1.request({ ...extra, url: 'sip-logs/web', method: 'GET', params })
  },
  webDetail(id, extra) {
    return API.Axios.error_capture.v1.request({ ...extra, url: `sip-logs/web/${encodeURIComponent(id)}`, method: 'GET' })
  },
  list(params = {}, extra) {
    return API.Axios.error_capture.v1.request({
      ...extra,
      url: `sip-logs`,
      method: 'GET',
      params,
    })
  },
  stats(params = {}, extra) {
    return API.Axios.error_capture.v1.request({
      ...extra,
      url: `sip-logs/stats`,
      method: 'GET',
      params,
    })
  },
  chart(params = {}, extra) {
    return API.Axios.error_capture.v1.request({
      ...extra,
      url: `sip-logs/chart`,
      method: 'GET',
      params,
    })
  },
}
